// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-dl-tooltip {
  padding: 16px;
  max-width: 300px;
}
.chartkit-dl-tooltip__popup[data-popper-reference-hidden=true] {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/ChartKit/components/ChartKitTooltip/ChartKitTooltip.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,gBAAA;AACJ;AACI;EACI,aAAA;AACR","sourcesContent":[".chartkit-dl-tooltip {\n  padding: 16px;\n  max-width: 300px;\n}\n.chartkit-dl-tooltip__popup[data-popper-reference-hidden=true] {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
